import { apiPathFunc } from "@api/util/apiPathFunc";
import type { IExtractParams } from "@/routes";
import { complete } from "@api/users/me/phoneNumberChange/complete/path";

const pathBase = `/users/me/phone-number-change/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const phoneNumberChange = {
  post: apiPathFunc(pathBase),
  complete,
};
